/**
 * Mapping for translation keys, so we don't have to use long text in source code. Please keep in mind, that the
 * german default translations are the keys, so don't change them, if you wan't to change the text.
 * Instead change the de_DE translations!
 */
export const KEYS = {
  DEFAULT: {},
  CRUD: {
    VARIABLE_EDITOR_CONDITION_DRAFT: 'Die Zuordnung wird erst beim Übernehmen der Bedingung ergänzt.',
    VARIABLE_EDITOR_NAME_REQUIRED: 'Bitte geben Sie einen Variablennamen ein.',
    VARIABLE_EDITOR_NAME_INVALID: 'Verwenden Sie einen gültigen Namen ohne Leerzeichen, zum Beispiel anzahlKartoffeln.',
    VARIABLE_EDITOR_NAME_DUPLICATE: 'Dieser Variablenname ist bereits vergeben.',
    VARIABLE_EDITOR_INITIAL_AVAILABILITY: 'Von Beginn an verfügbar',
    VARIABLE_EDITOR_SOURCE_UNASSIGNED: 'Quellfragebogen ist keinem Schritt zugeordnet',
    VARIABLE_EDITOR_AFTER_STEP: 'Nach Schritt',
    VARIABLE_EDITOR_UNNAMED: 'Ohne Namen',
    VARIABLE_EDITOR_DELETE_UNKNOWN: 'Nicht alle Bedingungen sind lesbar. Die Variable kann nicht sicher entfernt werden.',
    VARIABLE_EDITOR_DELETE_USED: 'Ändern Sie zuerst die Bedingungen, die diese Variable verwenden.',
    VARIABLE_EDITOR_RENAME_UNKNOWN: 'Nicht alle Bedingungen sind lesbar. Die Variable kann nicht sicher umbenannt werden.',
    VARIABLE_EDITOR_SOURCE_REQUIRED: 'Bitte wählen Sie eine Quelle.',
    VARIABLE_EDITOR_SOURCE_MISSING: 'Diese Quelle ist nicht verfügbar. Bitte wählen Sie eine andere Quelle.',
    VARIABLE_EDITOR_REMOVE: 'Variable entfernen',
    VARIABLE_EDITOR_EDIT: 'Variable bearbeiten',
    VARIABLE_EDITOR_ADD: 'Variable hinzufügen',
    VARIABLE_EDITOR_DELETE_HELP: 'Prüfen Sie die Verwendung vor dem Entfernen.',
    VARIABLE_EDITOR_EDITOR_HELP: 'Wählen Sie eine Quelle und geben Sie der Zuordnung einen Namen.',
    VARIABLE_EDITOR_CHOOSE_SOURCE: 'Quelle wählen',
    VARIABLE_EDITOR_SEARCH_SOURCE: 'Fragen, Antworten oder Patientendaten suchen',
    VARIABLE_EDITOR_LOADING: 'Quellen werden geladen…',
    VARIABLE_EDITOR_LOAD_FAILED: 'Einige Quellen konnten nicht geladen werden.',
    VARIABLE_EDITOR_RETRY: 'Erneut versuchen',
    VARIABLE_EDITOR_BOOLEAN: 'Ja / Nein',
    VARIABLE_EDITOR_NUMBER: 'Zahl',
    VARIABLE_EDITOR_DATE: 'Datum',
    VARIABLE_EDITOR_TEXT: 'Text',
    VARIABLE_EDITOR_NO_SOURCES: 'Keine passenden Quellen gefunden.',
    VARIABLE_EDITOR_SOURCE: 'Quelle',
    VARIABLE_EDITOR_CHANGE_SOURCE: 'Quelle ändern',
    VARIABLE_EDITOR_NAME: 'Variablenname',
    VARIABLE_EDITOR_NAME_HELP: 'Der Name wird in Bedingungen verwendet. In der Auswahl erscheint der sprechende Name der Quelle.',
    VARIABLE_EDITOR_RENAME_HELP: 'Die Verweise in den folgenden Schritten werden beim Übernehmen mit umbenannt.',
    VARIABLE_EDITOR_CHANGE_WARNING: 'Die vorhandenen Vergleichswerte bleiben erhalten. Prüfen Sie die Bedingungen nach dem Quellenwechsel.',
    VARIABLE_EDITOR_USAGES: 'Verwendet in Bedingungen',
    VARIABLE_EDITOR_UNUSED: 'Keine bekannten Verwendungen',
    VARIABLE_EDITOR_AVAILABILITY_HELP: 'Der Wert steht erst zur Verfügung, wenn der Quellschritt ausgeführt und der Fragebogen ausgefüllt wurde.',
    VARIABLE_EDITOR_BACK: 'Zurück',
    VARIABLE_EDITOR_TITLE: 'Workflow-Variablen',
    VARIABLE_EDITOR_OVERVIEW_HELP: 'Ordnen Sie Patientendaten oder Fragebogenwerte zu, um sie in Bedingungen zu verwenden.',
    VARIABLE_EDITOR_USAGES_UNKNOWN: 'Nicht alle Bedingungen sind lesbar. Einige Verwendungen können nicht angezeigt werden.',
    VARIABLE_EDITOR_EMPTY: 'Noch keine Variablen zugeordnet',
    VARIABLE_EDITOR_EMPTY_HELP: 'Beginnen Sie mit einer Quelle, zum Beispiel dem Alter oder einer Antwort aus einem Fragebogen.',
    VARIABLE_EDITOR_USED_IN: 'Verwendet in',
    VARIABLE_EDITOR_CREATE_FROM_CONDITION: 'Neue Variable zuordnen',
    VARIABLE_EDITOR_CONFLICT: 'Der Workflow wurde zwischenzeitlich geändert. Bitte öffnen Sie den Editor erneut.',
    VISUAL_FIRST_STEP_HELP: 'Bedingungen sind ab dem zweiten Schritt möglich.',
    VISUAL_EDIT: 'Bedingungen bearbeiten',
    VISUAL_MORE_OPTIONS: 'Weitere Optionen',
    VISUAL_RUN_STEP: 'SCHRITT AUSFÜHREN',
    VISUAL_RUN_WHEN: 'Diesen Schritt ausführen, wenn',
    VISUAL_ALWAYS_RUN: 'Dieser Schritt wird immer ausgeführt.',
    VISUAL_UNSUPPORTED: 'Dieser Ausdruck kann nicht im visuellen Editor bearbeitet werden. Er bleibt unverändert.',
    VISUAL_SHOW_EXPRESSION: 'Technischen Ausdruck anzeigen',
    VISUAL_APPLY_HELP: 'Änderungen werden erst mit Übernehmen wirksam.',
    VISUAL_CANCEL: 'Abbrechen',
    VISUAL_APPLY: 'Übernehmen',
    VISUAL_CONNECT: 'Bedingungen verknüpfen',
    VISUAL_ALL: 'Alle Bedingungen müssen zutreffen',
    VISUAL_ANY: 'Mindestens eine Bedingung muss zutreffen',
    VISUAL_REMOVE_GROUP: 'Gruppe entfernen',
    VISUAL_AND: 'UND',
    VISUAL_OR: 'ODER',
    VISUAL_CHOOSE_VARIABLE: 'Variable wählen',
    VISUAL_REMOVE_RULE: 'Bedingung entfernen',
    VISUAL_COMPARISON: 'Vergleich',
    VISUAL_VALUE: 'Vergleichswert',
    VISUAL_CHOOSE_VALUE: 'Wert wählen',
    VISUAL_EMPTY_GROUP: 'Bitte ergänzen oder entfernen Sie die leere Gruppe.',
    VISUAL_ADD_RULE: 'Bedingung hinzufügen',
    VISUAL_ADD_GROUP: 'Untergruppe hinzufügen',
    VISUAL_SOURCE_HELP: 'Wählen Sie eine der im Workflow zugeordneten Variablen.',
    VISUAL_SEARCH: 'Variablen durchsuchen',
    VISUAL_FILTER: 'Variablen filtern',
    VISUAL_SURVEY: 'Patient und Befragung',
    VISUAL_NO_MATCHES: 'Keine passenden Variablen gefunden.',
    VISUAL_NO_SOURCES: 'Noch keine Variablen zugeordnet. Fügen Sie eine neue Zuordnung hinzu.',
    VISUAL_BACK: 'Zurück zu den Bedingungen',
    VISUAL_VARIABLE_REQUIRED: 'Bitte wählen Sie eine Variable.',
    VISUAL_MISSING_VARIABLE: 'Diese Workflow-Variable existiert nicht mehr. Bitte ersetzen Sie sie.',
    VISUAL_INVALID_COMPARISON: 'Dieser Vergleich wird nicht unterstützt.',
    VISUAL_INVALID_VALUE: 'Bitte geben Sie einen gültigen Vergleichswert ein.',
    VISUAL_INVALID_DATE: 'Bitte geben Sie ein gültiges Datum ein.',
    VISUAL_EXISTING_EXPRESSION: 'Vorhandener Ausdruck',
    VISUAL_CONFLICT: 'Die Bedingungen wurden zwischenzeitlich geändert. Bitte öffnen Sie den Editor erneut.',
    VISUAL_UNCONDITIONAL_HELP: 'Sonst wird dieser Schritt immer ausgeführt.',
    VISUAL_AGE: 'Alter in Jahren',
    VISUAL_AGE_MONTHS: 'Alter in Monaten',
    VISUAL_BIRTH_DATE: 'Geburtsdatum',
    VISUAL_FIRST_NAME: 'Vorname',
    VISUAL_LAST_NAME: 'Nachname',
    VISUAL_FULL_NAME: 'Vollständiger Name',
    VISUAL_ANONYMOUS: 'Anonymer Patient',
    VISUAL_PSEUDONYMOUS: 'Pseudonymer Patient',
    VISUAL_CASE_NUMBER: 'Fallnummer',
    VISUAL_PATIENT_NUMBER: 'Patientennummer',
    VISUAL_POSTAL_CODE: 'Postleitzahl',
    VISUAL_CITY: 'Ort',
    VISUAL_STREET: 'Straße',
    VISUAL_STREET_NUMBER: 'Hausnummer',
    VISUAL_LOCATION: 'Standort',
    VISUAL_STATUS: 'Status',


    TEST_AUTOMATIC: 'Automatisch abgeleitet',
    TEST_DERIVATION_SOURCE: 'Grundlage für automatische Werte',
    TEST_DERIVATION_HELP: 'Alter wird zum heutigen Datum berechnet. Automatische Werte folgen den Patientendaten. Eigene Eingaben haben Vorrang, auch in späteren Schritten.',
    TEST_MR: 'Herr',
    TEST_MS: 'Frau',
    TEST_MALE: 'Männlich',
    TEST_FEMALE: 'Weiblich',
    TEST_DIVERSE: 'Divers',
    TEST_CHANGED_VALUE: 'Wert geändert',
    TEST_SKIPPED: 'Übersprungen',
    TEST_CHANGED_VALUES: 'Werte geändert',
    TEST_CLOSE: 'Schließen',
    TEST_BACK_TO_DIAGRAM: 'Zurück zum Ablauf',

    TEST_INPUTS: 'Testeingaben',
    TEST_DIAGRAM_HELP: 'Simuliert die Antworten pro Schritt. Die gemappten Werte werden nach dem Ausfüllen übernommen und entscheiden über die nächsten Schritte.',
    TEST_KEEP_HELP: '„Wert setzen“ übernimmt die Eingabe beim Ausführen dieses Schritts. Sonst bleibt der bisherige Wert erhalten. Übersprungene Schritte ändern keine Werte.',
    TEST_SURVEY_VALUES: 'Befragungs- und Patientendaten',
    TEST_UNSET: 'Nicht gesetzt',
    TEST_PAUSE: 'Pause',
    TEST_PAUSED: 'Pausiert',
    TEST_CONTINUE: 'Fortsetzen',
    TEST_NEXT: 'Einzelschritt',
    TEST_RESET: 'Zurücksetzen',
    TEST_START: 'Start',
    TEST_END: 'Ende',
    TEST_SET_VALUE: 'Wert setzen',
    TEST_KEEP_VALUE: 'Bisheriger Wert',
    TEST_LOCAL_ONLY: 'Nur lokal, ohne Speichern',
    TEST_STEPS_CHECKED: 'Schritte geprüft',
    TEST_COMPLETED: 'Ausgeführt',
    TEST_SOURCE_UNAVAILABLE: 'Fragebogen nicht verfügbar. Die Zuordnungen können nicht geladen werden.',
    TEST_NO_MAPPING: 'Keine Workflow-Variablen aus diesem Fragebogen zugeordnet.',

    AND: 'und',
    OR: 'oder',
    EQUALS: 'ist gleich',
    NOT_EQUALS: 'ist ungleich',
    GREATER_THAN: 'ist größer als',
    LESS_THAN: 'ist kleiner als',
    AT_LEAST: 'ist mindestens',
    AT_MOST: 'ist höchstens',
    MISSING_EXAMPLE: 'Beispielwert fehlt',
    NO_CONDITION: 'Keine Bedingung',
    CHECK_PREVIOUS_STEP: 'Vorherigen Schritt zuerst prüfen',
    FIRST_ALWAYS_RUNS: 'Der erste Schritt wird immer ausgeführt',
    SOURCE_NOT_EXECUTED: 'Der zugehörige Fragebogen wurde vorher nicht ausgeführt',
    CONDITION_UNDETERMINED: 'Bedingung kann noch nicht geprüft werden',
    TEST_CONDITION_MET: 'Bedingung erfüllt',
    TEST_CONDITION_NOT_MET: 'Bedingung nicht erfüllt',

    CONFIRM_LEAVE: 'Es gibt ungespeicherte Änderungen. Möchten Sie den Editor trotzdem verlassen?',
    WAIT_FOR_SAVE: 'Der Workflow wird gerade gespeichert. Bitte warten Sie kurz.',
    TEST_FLOW: 'Ablauf testen',
    TEST_HELP: 'Prüfe die Bedingungen mit Beispielwerten. Es wird keine Befragung gestartet und nichts gespeichert.',
    TEST_VALUES_HELP: 'Die Beispielwerte gelten für diesen Testlauf. Fragebogenwerte stehen erst nach dem jeweiligen Schritt zur Verfügung. Ohne „Wert verwenden“ gilt ein Wert als fehlend.',
    EXAMPLE_VALUE: 'Beispielwert',
    USE_VALUE: 'Wert verwenden',
    RUN_TEST: 'Testlauf starten',
    TEST_STALE: 'Werte oder Workflow geändert. Bitte erneut testen.',
    TEST_UNKNOWN: 'Noch offen',
    TEST_BLOCKED: 'Testlauf angehalten',
    TEST_COMPLETE_VALUE: 'Testwert ergänzen',
    TEST_RETRY_AFTER_INPUT: 'Danach den Testlauf erneut starten. Der Wert wird vor dieser Bedingung benötigt.',
    TEST_EXECUTE: 'Wird ausgeführt',
    TEST_SKIP: 'Wird übersprungen',
    TEST_REASON: 'Auswertung anzeigen',
    CONDITION_MET: 'Erfüllt',
    CONDITION_NOT_MET: 'Nicht erfüllt',
    YES: 'Ja',
    NO: 'Nein',
    REVIEW_HINT: 'Hinweis prüfen',
    REVIEW_HINTS: 'Hinweise prüfen',
    MISSING_NAME: 'Workflow-Namen ergänzen',
    MISSING_STEPS: 'Mindestens einen Schritt hinzufügen',
    INVALID_CONDITION: 'Bedingung ist unvollständig oder wird nicht unterstützt',
    MISSING_VARIABLE: 'Variable ist nicht definiert',
    LATE_VARIABLE: 'Ein Fragebogen mit dieser Quellvariable muss in einem vorherigen Schritt stehen',
    ONLY_IF: 'Nur wenn',
    CHECK_CONDITION: 'Bedingung prüfen',
    MOVE_STAGE: 'Schritt verschieben',
    STEP_ACTIONS: 'Schrittaktionen',
    MOVE_UP: 'Nach oben verschieben',
    MOVE_DOWN: 'Nach unten verschieben',
    DUPLICATE_STAGE: 'Schritt duplizieren',
    COPY: 'Kopie',
    CONFIRM_FIRST_STAGE: 'Der erste Schritt wird immer ausgeführt. Sollen seine Bedingungen entfernt und die Reihenfolge geändert werden?',
    OPTIONAL: 'Optional',
    EXPAND_ALL: 'Alle aufklappen',
    COLLAPSE_ALL: 'Alle zuklappen',
    EMPTY_STEPS: 'Füge den ersten Schritt hinzu und ordne ihm Fragebögen zu.',
    NO_QUESTIONNAIRES: 'Keine Fragebögen zugeordnet',
    ALWAYS_EXECUTE: 'Immer ausführen',
    CONDITION: 'Bedingung',
    EXECUTION: 'Ausführung',
    OUTPUT: 'Ausgabe',
    TO_STAGE: 'Zum Schritt',
    REMOVE_CONDITIONS: 'Bedingungen entfernen',
    UNSAVED_CHANGES: 'Ungespeicherte Änderungen',
    NO_UNSAVED_CHANGES: 'Keine ungespeicherten Änderungen',
    SAVING: 'Wird gespeichert...',

    WORKFLOW: 'Workflow',
    STAGES: 'Schritte',
    VARIABLES: 'Variablen',
    CONDITIONS: 'Bedingungen',
    STAGE: 'Schritt',
    STAGE_NAME: 'Name',
    STAGE_DESCRIPTION: 'Beschreibung',
    STAGE_QUESTIONNAIRES: 'Fragebögen',
    ENTER_WORKFLOW_NAME: 'Workflow-Name eingeben',
    ENTER_WORKFLOW_DESCRIPTION: 'Workflow-Beschreibung eingeben',
    ENTER_STAGE_NAME: 'Schrittnamen eingeben',
    ENTER_STAGE_DESCRIPTION: 'Schrittbeschreibung eingeben',
    ADD_STAGE: 'Schritt hinzufügen',
    DELETE_STAGE: 'Schritt löschen',
    CONFIRM_DELETE_STAGE: 'Möchten Sie diesen Schritt wirklich löschen?',
    SAVE_WORKFLOW: 'Speichern',
    SUCCESSFULLY_SAVED_WORKFLOW: 'Workflow erfolgreich gespeichert!',
    ERROR_SAVING_WORKFLOW: 'Fehler beim Speichern des Workflows!',
    ERROR_LOADING_WORKFLOW: 'Fehler beim Laden des Workflows!',
    CONFIRM_DELETE_WORKFLOW: 'Möchten Sie diesen Workflow wirklich löschen?',
    FOUND_NO_ENTRY_BY_ID: 'Kein Eintrag gefunden mit der ID',

    DELETE_WORKFLOW: 'löschen',
    CLOSE_WINDOW: 'Fenster schließen',
    GENERATE_EXPORTS: 'Export Formate generieren',
    GENERATE_FORM_PDFS: 'PDF Formulare generieren',
    SKIP_SIGNING: 'Unterschrift überspringen',
    AUTO_START_STEP: 'Schritt automatisch starten',
    PREFILL: 'Vorausfüllen',
    VARIABLE_NAME: 'Name',
    VARIABLE_TYPE: 'Typ',
    VARIABLE_QUESTIONNAIRE: 'Fragebogen',
    VARIABLE_SURVEY: 'Befragung',
    VARIABLE_VARIABLE: 'Variable',
    VARIABLE_OPTIONS: 'Optionen',
    VARIABLE_ADD: 'Hinzufügen',
    PLEASE_SELECT: 'Bitte wählen...',
    VARIABLE_HELP: 'Definieren Sie Variablen, indem Sie einen Namen, einen Fragebogen und eine Fragebogen-Variable auswählen. Diese Workflow-Variablen können in Bedingungen verwendet werden, um Schritte auszuführen oder zu überspringen.',
    WARNING_LAST_STAGE_CONSTRAINTS: 'Achtung: Im letzten Schritt kann das Generieren von Export-Formaten und PDF-Formularen nicht deaktiviert werden. Unterschriften können nicht übersprungen werden.',
    // Conditions tab helpers and labels
    CONDITIONS_HELP_INFO: 'Hier können Sie für einen Schritt Bedingungen festlegen. Sind die Bedingungen erfüllt, wird der Schritt ausgeführt – andernfalls übersprungen.',
    CONDITIONS_DEV_FEATURE_IN_PROGRESS: 'Feature in Entwicklung!',
    CONDITIONS_DEV_EVAL_NOT_IMPLEMENTED: 'Die Definition von Variablen und Bedingungen ist bereits möglich, ihre Auswertung ist allerdings noch nicht implementiert.',
    CONDITIONS_FOR_STAGE: 'Bedingungen für Schritt:',
    CONDITIONS_ADD: 'Hinzufügen',
    CONDITIONS_ONLY_EXECUTE_IF: 'nur ausführen wenn:',
  },
  GRID: {
    USER: 'Benutzer',
    ID: 'Id',
    SEARCH: 'Suche',
    FOUND_NO_ENTRY_BY_ID: 'Kein Eintrag gefunden mit der ID',
    CONFIRM_DELETE_WORKFLOW: 'Möchten Sie diesen Workflow wirklich löschen?',
    SUCCESSFULLY_DELETED_WORKFLOW: 'Workflow erfolgreich gelöscht!',
    ERROR_DELETING_WORKFLOW: 'Fehler beim Löschen des Workflows!',
    WORKFLOW: 'Workflow',
    PATIENT: 'Patient',
    STATUS: 'Status',
    STATUS_CREATED: 'Erstellt / In Bearbeitung',
    STATUS_ASSIGNED: 'In Bearbeitung',
    STATUS_SUBMITTED: 'Abgeschlossen',
    STATUS_SIGNED: 'Abgeschlossen / Unterschrieben',
    STATUS_CANCELED: 'Abgebrochen',
    STATUS_SKIPPED: 'Übersprungen',
    STATUS_UNKNOWN: 'Unbekannt',
    STATUS_EXPIRED: 'Abgelaufen',
    WORKFLOW_INSTANCES: 'Workflow-Instanzen',
    PATIENT_ID: 'PatNr.',
    CASE_NR: 'Fall-Nr.',
    ANONYMOUS: 'Anonym',
    PSEUDONYMOUS: 'Pseudonym',
    MR: 'Herr',
    MS: 'Frau',
    CONTINUE_WORKFLOW: 'Workflow fortsetzen',
    SUBMISSIONS: 'Abgaben',
    ASSETS: 'Dateien',
    COPY_LINK_SUCCESS: 'Link erfolgreich kopiert!',
    COPY_LINK_ERROR: 'Fehler beim Kopieren des Links!',
    COPY_LINK_TO_CONTINUE: 'Link zum Fortsetzen kopieren',
    SHOW_QR_CODE_TO_CONTINUE: 'QR Code zum Fortsetzen anzeigen',
    ERROR_LOADING_QR_CODE: 'Beim Laden des QR Codes ist ein Fehler aufgetreten!',
    QUESTIONNAIRES: 'Fragebögen',
    ERROR_MISSING_MANDATORY_CONFIG: 'Die Konfiguration enthält keine API URL zum Abrufen von Workflows!',
    ERROR_LOADING_WORKFLOWS: 'Beim Laden der Workflows ist ein Fehler aufgetreten!',
    CONFIG_ERROR: 'Konfigurationsfehler',
    WORKFLOWS: 'Workflows',
    NAME: 'Name',
    DESCRIPTION: 'Beschreibung',
    EDIT: 'Bearbeiten',
    DELETE: 'Löschen',
    ENABLED: 'Aktiv',
    DISABLED: 'Inaktiv',
    NOT_STARTED: 'Nicht gestartet',
    SHOW_HISTORY: 'Verlauf anzeigen',
    HIDE_HISTORY: 'Verlauf ausblenden',
    OPEN_TEMPLATE: 'Vorlage öffnen',
    VALID_UNTIL: 'Gültig bis',
    SUBMISSION: 'Abgabe',
    SUBMITTED_AT: 'Abgabe vom',
    NO_FILES: 'Keine Dateien vorhanden',
    NO_STAGES: 'Keine Schritte',
    NO_QUESTIONNAIRES: 'Keine Fragebögen zugeordnet',
    QUESTIONNAIRE_UNAVAILABLE: 'Fragebogen nicht verfügbar',
    STAGES: 'Schritte',
    GENERATE_EXPORTS: 'Export Formate generieren',
    GENERATE_FORM_PDFS: 'PDF Formulare generieren',
    PREFILL: 'Vorausfüllen',
    STAGE: 'Schritt',
    OPTIONS: 'Optionen',
    CREATED_AT: 'Erstellt am',
    UPDATED_AT: 'Bearbeitet am',
    ENTRIES: 'Einträge',
    MARKED_DONE: 'Als erledigt markiert',
    DONE: 'Erledigt',
    EXTERN: 'Extern',
    EXTERN_STATUS_OPEN: 'Offen',
    EXTERN_STATUS_PENDING: 'In Bearbeitung',
    EXTERN_STATUS_DONE: 'Fertig',
    TYPE: 'Typ',
    TYPE_ALL: 'Alle',
    TYPE_NOT_ANONYMOUS: 'Nicht anonym / pseudonym',
    TYPE_ANONYMOUS: 'Anonym',
    TYPE_PSEUDONYMOUS: 'Pseudonym',
    AUTO_REFRESH: '-',
    EXPORT_WORKFLOW: 'Workflow exportieren',
    IMPORT_WORKFLOW: 'Workflow importieren',
    SUCCESS_IMPORTING_WORKFLOW: 'Workflow erfolgreich importiert!',
    SUCCESS_IMPORTING_WORKFLOW_DETAILS: 'Workflow erfolgreich importiert! Fragebögen: [[imported]] importiert, [[skipped]] übersprungen. Assets: [[assetsImported]] übertragen.',
    WARNING_IMPORTING_WORKFLOW_ASSETS: 'Achtung: [[assetsErrors]] Asset-Upload(s) fehlgeschlagen.',
    ERROR_IMPORTING_WORKFLOW: 'Fehler beim Importieren des Workflows!',
    ERROR_EXPORTING_WORKFLOW: 'Fehler beim Exportieren des Workflows!',
  }
};

